export type EntityRefResolution<TItem> =
    | { state: "loading" }
    | { state: "resolved"; item: TItem }
    | { state: "unresolved" };

/**
 * Looks a pill's reference up in live data. `lookup` is `undefined` until
 * that data has loaded, so a pill never reports a reference as gone just
 * because its data hasn't arrived yet.
 */
export function resolveEntityRef<TKey, TItem>({
    lookup,
    key,
}: {
    lookup: ReadonlyMap<TKey, TItem> | undefined;
    key: TKey;
}): EntityRefResolution<TItem> {
    if (!lookup) {
        return { state: "loading" };
    }
    const item = lookup.get(key);
    return item === undefined
        ? { state: "unresolved" }
        : { state: "resolved", item };
}
